import React, { useCallback, useEffect, useState } from 'react';
import Table from '../components/Table';
import Pagination from '../components/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { GetSupportApi } from '../redux/actions/teams/members/GetSupportAction';
import { PulseLoader } from 'react-spinners';

const Support = () => {
    const columns = ['Full Name', 'Email Address','Created On','Status','Action'];
    const { response: listResponse, loading: listLoading, error: listError } = useSelector((state) => state.supportList);
    
    const dispatch = useDispatch();
    const location = useLocation();

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [limit, setLimit] = useState(5);
    const [dataList, setDataList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
     const [isToggled, setIsToggled] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchUsersList = useCallback((currentPage,limit,searchTerm,status) => {
        dispatch(GetSupportApi(currentPage, limit, searchTerm,status));
    }, [dispatch]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleLimitChange = (newLimit) => {
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleSearchChange = (term) => {
        setSearchTerm(term);
        if (searchTerm !== term) {
            setCurrentPage(1); 
        }
    };

     const handleStatusChange = (status) => {
        setSelectedStatus(status);
        setCurrentPage(1); 
    };

    const handleRetry = () => {
  window.location.reload(); // or trigger your data-fetching again
    };

      useEffect(() => {
        if (isToggled) {
            fetchUsersList(currentPage, limit, searchTerm, selectedStatus);
            setIsToggled(false);
        }
    }, [isToggled, fetchUsersList, currentPage, limit, searchTerm, selectedStatus]);

    useEffect(() => {
        if (location.pathname === '/dashboard/support-management') {
            setCurrentPage(1);
            setLimit(5);
            setSearchTerm('');
            setSelectedStatus('');
        }
    }, [location]);

    useEffect(() => {
        fetchUsersList(currentPage,limit,searchTerm,selectedStatus);
    }, [currentPage,limit,searchTerm,selectedStatus,fetchUsersList]);

 useEffect(() => {
  if (listResponse?.status) {

    setCurrentPage(listResponse?.data?.currentPage);
    setTotalPages(listResponse?.data?.totalPages);
    setTotalItems(listResponse?.data?.totalItems);
    setDataList(listResponse?.data?.result || []);
  }
}, [listResponse]);

    return (
        <div className="content-wrapper">
            <section className="main-section spacer-y">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-12">
                            <div className="common_sub_heading_wrapper">
                                <h2>Support</h2>
                                <div className="d-flex gap-2 align-items-center">
                                    {/* Status Dropdown */}
                                    <select
                                        className="form-select"
                                        value={selectedStatus}
                                        onChange={(e) => handleStatusChange(e.target.value)}
                                        style={{ width: 'auto' }}
                                    >
                                        <option value="">All Status</option>
                                        <option value="Not_review">Not Review</option>
                                        <option value="Review">Review</option>
                                        <option value="Resolve">Resolve</option>
                                    </select>
                                </div>
                            </div>
                               {/* Keep the search input where it was */}
                           <div className="mb-3 position-relative" style={{ maxWidth: '300px' }}>
                            <input
                                type="text"
                                className="form-control ps-4"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => handleSearchChange(e.target.value)}
                            />
                            <span className="position-absolute top-50 start-0 translate-middle-y ms-2">
                                <i className="fas fa-search text-muted"></i>
                            </span>
                        </div>
                          
                            <div className="tab-content common_tab_content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-1" role="tabpanel" aria-labelledby="pills-1-tab" tabIndex="0">
                                    {listLoading ? (
                                        <div style={{ height: '40vh' }} className="d-flex align-items-center justify-content-center">
                                            <PulseLoader size={25} color="#49a496" />
                                        </div>
                                    ) : listError ? (
                                    
                                        <div className="center-container">
                                                <div className="error-box">
                                                <i className="bi bi-exclamation-triangle-fill"></i>
                                                <p>Something went wrong</p>
                                                <button className="retry-btn" onClick={handleRetry}>
                                                    Try Again
                                                </button>
                                                </div>
                                            </div>
                                    ) : (
                                        <>
                                            <Table
                                                tableData={dataList}
                                                setDataList={setDataList}
                                                limit={limit}
                                                columns={columns}
                                                currentPage={currentPage}
                                                handlePageChange={handlePageChange}
                                                setLimit={handleLimitChange}
                                                title={'support'}
                                                setIsToggled={setIsToggled}
                                            />
                                            {dataList?.length > 0 && (
                                                        <Pagination
                                                            currentPage={currentPage}
                                                            totalPages={totalPages}
                                                            limit={limit}
                                                            totalItems={totalItems}
                                                            handlePageChange={handlePageChange}
                                                            handleLimitChange={handleLimitChange}
                                                        />
                                                        )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Support;